import React from 'react'
import PropTypes from 'prop-types'
import {Spin} from "antd"
import UserHead from "./UserHead"
import UserBody from "./UserBody"

UserTable.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    listUsers: PropTypes.array
}

function UserTable(props) {
    const {loading, error, listUsers, selectAll, onCheckALl, arrSelected, onSelected, onShowEdit} = props

    return (
        <div className="CustomersTable">
            <Spin spinning={loading} tip="Đang lấy dữ liệu">
                <table className="layoutFixed usersTable">
                    <UserHead
                        selectAll={selectAll}
                        onCheckALl={onCheckALl}
                        arrSelected={arrSelected}
                    />
                    <UserBody
                        error={error}
                        listUsers={listUsers}
                        arrSelected={arrSelected}
                        onSelected={onSelected}
                        onShowEdit={onShowEdit}
                    />
                </table>
            </Spin>
        </div>
    )
}

export default UserTable
